export const getGlyphName = (hasChildren, collapsed, selected) => {
  return hasChildren
    ? collapsed
      ? "add"
      : "remove"
    : selected
      ? "done"
      : null;
};
